"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreuiHeader = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_router_dom_1 = require("react-router-dom");
const CoreuiHeaderSideBarToggle_1 = require("./CoreuiHeaderSideBarToggle");
const CoreuiHeaderComponent = ({ title, headerRightText, brandUrl }) => (react_1.default.createElement("div", { className: "app-header navbar", style: { paddingRight: '20px' } },
    react_1.default.createElement(CoreuiHeaderSideBarToggle_1.CoreuiHeaderSideBarToggle, { buttonClass: "navbar-toggler mobile-sidebar-toggler d-md-none mr-auto", toggleClass: "sidebar-show" }),
    react_1.default.createElement(react_router_dom_1.Link, { to: brandUrl, className: "navbar-brand" }, title),
    react_1.default.createElement("ul", { className: "nav navbar-nav ml-auto d-none d-sm-block" },
        react_1.default.createElement("li", { className: "nav-item px-3" }, headerRightText))));
CoreuiHeaderComponent.propTypes = {
    title: prop_types_1.default.node.isRequired,
    brandUrl: prop_types_1.default.string,
    headerRightText: prop_types_1.default.node,
};
CoreuiHeaderComponent.defaultProps = {
    brandUrl: '/',
    headerRightText: '',
};
exports.CoreuiHeader = CoreuiHeaderComponent;
//# sourceMappingURL=CoreuiHeader.js.map